var _g, _rect, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGseHelpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.9,5.3c13.7,0,26.6,1.6,36.3,4.6,8.9,2.7,14.3,6.5,14.3,10s-5.3,7.3-14.3,10c-9.7,3-22.6,4.6-36.3,4.6s-26.6-1.6-36.3-4.6c-8.9-2.7-14.3-6.5-14.3-10s5.3-7.3,14.3-10c9.7-3,22.6-4.6,36.3-4.6M52.9,4.1C24.2,4.1,1,11.2,1,19.9s23.2,15.9,51.9,15.9,51.9-7.1,51.9-15.9-23.2-15.9-51.9-15.9h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,13.2s0,0,0,0c-1.2-.7-2.7-1-4.4-1h-9.9c0,0-.1,0-.1,0l-4.2,15.3s0,0,0,.1c0,0,0,0,.1,0h5.3s0,0,0,0c0,0,.1,0,.1,0l3.8-13.6h2.5c.9,0,1.7.3,2.3.8.6.6.9,1.4.9,2.4s-.6,2.2-1.7,2.9c-.8.5-1.9.8-3.3,1-.6,0-1.2.1-1.8.1s-.1,0-.1,0l-.4,1.5s0,0,0,.1c0,0,0,0,0,0,.2,0,.3,0,.5,0,.2,0,.4,0,.8,0,1.6,0,3.1-.1,4.5-.4,2.1-.4,3.7-1,4.9-1.8,1.5-1.1,2.3-2.6,2.3-4.5s-.7-2.5-2.1-3.3Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,23s-.1,0-.2,0c-.7.6-1.3,1-1.7,1.3-1.3.8-2.4,1.3-3.2,1.3s-2-.3-2.6-.9c-.7-.7-1-1.6-1-2.9s.7-3.3,2.2-4.9c1.4-1.5,2.7-2.3,3.9-2.3s1.6.3,2,.9c.3.4.4,1.1.4,1.9s0,.6,0,.9c0,.2,0,.5-.1.6,0,0,0,0,0,.1,0,0,0,0,.1,0h2.2c0,0,.1,0,.1,0l1.6-6s0,0,0-.1c0,0,0,0,0,0-.7-.1-1.3-.2-1.7-.2-1.2-.1-2.3-.2-3.1-.2-3.5,0-6.5.8-8.9,2.5-2.6,1.7-3.9,4-3.9,6.9s.8,3.7,2.5,4.8c1.4,1,3.3,1.5,5.6,1.5s3-.3,4.5-.9c1-.4,1.9-.9,2.7-1.6l.9-.8s0,0,0-.1c0,0,0,0,0,0l-2.2-1.3Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,12.4s0,0,0,0c-.9-.1-1.6-.2-2-.2-1.5-.1-2.8-.2-3.8-.2-1.8,0-3.5.1-5,.4-1.8.3-3.3.9-4.3,1.7-1.2.9-1.9,2.1-1.9,3.6s.9,2.5,2.6,3.1c1.5.3,3.1.6,4.7.9,1.5.3,2.3.8,2.3,1.6s-.6,1.4-1.7,1.9c-1,.4-2.1.6-3.3.6s-2.7-.3-4.1-.8c-.4-.2-1-.4-1.6-.8,0,0,0,0-.1,0,0,0,0,0,0,.1v2.8c0,0,0,.1,0,.1.9.2,1.6.4,2.1.5,1.6.3,2.9.5,3.9.5,2.6,0,5-.5,7-1.4,2.4-1,3.6-2.4,3.6-4s-.9-2.4-2.7-3.2c-1.6-.4-3.2-.8-4.8-1.2-1.6-.4-2.3-1-2.3-1.6s.5-1.5,1.4-2c.8-.4,1.8-.6,3-.6s1.7,0,2.1.2c.4.1.7.3.9.6.2.2.3.5.4.8,0,.3,0,.7,0,1.1,0,.2,0,.4,0,.5v.2c0,0,0,.1.1.1h2.1c0,0,.1,0,.1,0l1.5-5s0,0,0-.1Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 12.2,
    width: 0.7,
    height: 18.3,
    fill: "#fff",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.7,21.2v-2.1h5.9v5c-.6.5-1.4,1-2.5,1.4s-2.2.6-3.3.6-2.7-.3-3.7-.8-1.9-1.3-2.4-2.4-.8-2.1-.8-3.3.3-2.5.9-3.5,1.5-1.8,2.6-2.3c.9-.4,2-.6,3.3-.6s3,.3,4,1,1.6,1.6,1.8,2.7l-2.7.5c-.2-.6-.6-1.1-1.1-1.5s-1.2-.5-2-.5c-1.2,0-2.2.4-2.9,1.1s-1.1,1.7-1.1,3.1.4,2.6,1.1,3.4,1.7,1.1,2.8,1.1,1.2-.1,1.7-.3,1.1-.5,1.5-.8v-1.6h-3.1Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,21.8l2.7-.2c.2.8.5,1.4,1,1.8.5.4,1.2.6,2,.6s1.5-.2,2-.5.7-.7.7-1.2,0-.5-.3-.8-.5-.4-1-.5c-.3-.1-1.1-.3-2.2-.5-1.5-.3-2.5-.8-3.1-1.2-.8-.7-1.3-1.5-1.3-2.5s.2-1.2.6-1.8,1-1,1.7-1.3,1.6-.4,2.7-.4c1.7,0,3,.3,3.9,1s1.3,1.6,1.4,2.8h-2.7c-.1-.5-.4-1-.8-1.3s-1-.4-1.7-.4-1.4.2-1.9.5c-.3.2-.4.5-.4.8s.1.6.4.8c.3.3,1.2.5,2.5.8s2.3.6,3,.9,1.1.7,1.5,1.3.5,1.2.5,2-.2,1.4-.6,2-1,1.1-1.8,1.4-1.8.5-3,.5c-1.7,0-3-.4-4-1.1s-1.5-1.8-1.6-3.2Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,25.9v-12.6h10.1v2.1h-7.3v2.8h6.8v2.1h-6.8v3.4h7.6v2.1h-10.3Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,25.9v-12.6h1.8v5.2h7.1v-5.2h1.8v12.6h-1.8v-5.9h-7.1v5.9h-1.8Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,22.9l1.7.2c-.3.9-.8,1.7-1.5,2.2s-1.7.8-2.8.8-2.6-.4-3.4-1.2-1.3-2-1.3-3.4.4-2.7,1.3-3.6c.9-.8,2-1.3,3.3-1.3s2.4.4,3.2,1.2,1.3,2,1.3,3.5,0,.2,0,.4h-7.3c0,1,.4,1.8.9,2.3s1.2.8,2.1.8,1.1-.1,1.6-.4.8-.8,1-1.4ZM186.3,20.4h5.5c0-.8-.3-1.3-.6-1.7-.5-.6-1.2-.9-2.1-.9s-1.4.2-1.9.7-.8,1.1-.9,1.9Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5,25.9v-12.6h1.7v12.6h-1.7Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,29.3v-12.6h1.5v1.2c.4-.5.8-.8,1.2-1s1-.3,1.6-.3,1.6.2,2.2.6,1.1,1,1.5,1.7.5,1.5.5,2.4-.2,1.8-.5,2.5-.9,1.3-1.6,1.7-1.4.6-2.2.6-1.1-.1-1.5-.3-.8-.5-1.1-.8v4.4h-1.7ZM201.3,21.4c0,1.2.3,2,.8,2.6s1.1.8,1.9.8,1.4-.3,1.9-.9.8-1.5.8-2.7-.3-2-.8-2.6-1.1-.9-1.8-.9-1.3.3-1.9.9-.8,1.5-.8,2.7Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.8,25.9v-1.8h1.9v1.8h-1.9Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,22.5l1.6.2c-.2,1-.6,1.9-1.4,2.5-.7.6-1.6.9-2.7.9s-2.4-.4-3.2-1.2-1.2-2-1.2-3.5.2-1.8.5-2.6.9-1.3,1.6-1.7,1.5-.6,2.3-.6,1.9.2,2.6.7,1.1,1.2,1.3,2.1l-1.6.2c-.2-.6-.4-1.1-.8-1.4s-.9-.5-1.4-.5c-.8,0-1.5.3-2,.8s-.8,1.4-.8,2.6.3,2.1.8,2.7,1.2.8,2,.8,1.2-.2,1.6-.6.7-.9.8-1.7Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5,21.3c0-1.7.5-2.9,1.5-3.7.8-.7,1.9-1,3.1-1s2.5.4,3.3,1.2,1.3,2,1.3,3.4-.2,2.1-.6,2.8c-.4.7-.9,1.2-1.7,1.6s-1.5.6-2.4.6c-1.4,0-2.5-.4-3.3-1.2-.9-.8-1.3-2-1.3-3.5ZM226.2,21.3c0,1.2.3,2,.8,2.6s1.2.9,2.1.9,1.5-.3,2.1-.9.8-1.5.8-2.7-.3-2-.8-2.6-1.2-.9-2.1-.9-1.5.3-2.1.9-.8,1.4-.8,2.6Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,25.9v-9.1h1.5v1.3c.3-.4.7-.8,1.2-1.1s1.1-.4,1.8-.4,1.3.1,1.8.4c.5.3.8.7,1,1.2.8-1.1,1.8-1.6,3-1.6s1.7.2,2.3.7.8,1.3.8,2.3v6.2h-1.7v-5.7c0-.6,0-1.1-.2-1.3-.1-.3-.3-.5-.6-.7s-.6-.2-1-.2c-.7,0-1.3.2-1.7.6s-.7,1.1-.7,2v5.3h-1.7v-5.9c0-.7-.1-1.2-.4-1.5s-.7-.5-1.3-.5-.9.1-1.3.3c-.4.2-.7.6-.9,1s-.3,1.1-.3,1.9v4.7h-1.7Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGseHelpLogo);
export default __webpack_public_path__ + "static/media/gse-help-logo.9f182c0990fc36c082a78637cf75ddfc.svg";
export { ForwardRef as ReactComponent };